import Vue from "vue";

export default {
  namespaced: true,
  state: {
    exam: null,
  },
  getters: {
    exam: (state) => state.exam,
  },
  mutations: {
    SET_EXAM(state, payload) {
      state.exam = payload
    },
  },
  actions: {
    async loadExams({commit}, id) {
      const params = {
        application_id: id,
      }

      await Vue.axios.get('application/protector_exams/', {params})
        .then((response) => {
          commit('SET_EXAM', response.data)
        })
    },
  }
}
